"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function f(ele) {
    var list = ele.getAttributeNames();
    list.forEach(function (name) {
        ele.removeAttribute(name);
    });
    for (var i = 0; i < ele.children.length; i++) {
        f(ele.children[i]);
    }
}
exports.default = f;
